// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import type { FeatureFlagsConfig, BuildEnvironment } from 'src/environments/environment.types';
import {HEAP_ID_PROD as heapId} from "./constants/heap";
import { responseType, scope, audience, isPkceFlowMode, softwareVersion } from './constants';

export const API_URL_LOC = 'https://rdo-api.rouseanalytics.com';
export const METRICS_API_URL = 'https://metrics-api.rouseanalytics.com';
export const CLIENT_ID = 'mgXIM36xf9jazV1iLS0MC9057RtMgFo3';
export const DOMAIN = 'login.rouseservices.com';
export const PLATFORM = 'Production';
export const UKTESTINGNAMES = 'test.uk-performancetesting.admin@sbtuk.com';

const featureFlags: FeatureFlagsConfig = {
  flagEnableFilters: true,
  flagEnableCommissionEstimates: false,
  flagEnableGeographyStats: true,
}

export const environment:BuildEnvironment = {
  ...featureFlags,
  apiUrl: API_URL_LOC,
  clientId: CLIENT_ID,
  domain: DOMAIN,
  responseType,
  scope,
  audience,
  softwareVersion,
  isPkceFlowMode,
  heapId,
  metricsApiUrl: METRICS_API_URL,
  platform: PLATFORM,
  sentryTraceSampleRate: 0.2,
  ukTestingNames: UKTESTINGNAMES,
};
